import React, { useState } from "react";
import zeilbootIcon from "../assets/icons/zeilbootGrijs.png";
import motorbootIcon from "../assets/icons/motorbootGrijs.png";
import jetskiIcon from "../assets/icons/jetskiGrijs.png";
import ribIcon from "../assets/icons/ribGrijs.png";

const bootTypes = [
  { type: "Zeilboot", label: "Zeilboot", icon: zeilbootIcon },
  { type: "Motorboot", label: "Motorboot", icon: motorbootIcon },
  { type: "Jetski", label: "Jetski", icon: jetskiIcon },
  { type: "RIB", label: "RIB", icon: ribIcon },
];

const BoatType = ({ onNext, formData }) => {
  const [selectedType, setSelectedType] = useState(formData.boatType || "");

  const handleSelect = (type) => {
    setSelectedType(type);
  };

  const handleNext = () => {
    if (selectedType) {
      onNext({ ...formData, boatType: selectedType });
    }
  };

  return (
    <div className="boat-type-page px-6 py-12 sm:py-16 lg:px-8 lg:py-20">
      <div className="mx-auto max-w-7xl">
        <h1 className="text-3xl font-semibold mb-6 text-center text-[#1a2a6c]">
          Kies jouw type boot voor een{" "}
          <span className="text-[#ff6f61]">snelle offerte</span> aanvraag
        </h1>
        <div className="mt-16 grid grid-cols-2 gap-4 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {bootTypes.map((boot) => (
            <div
              key={boot.type}
              onClick={() => handleSelect(boot.type)}
              className={`flex flex-col items-center text-center cursor-pointer rounded-lg transition-all duration-300
      ${
        selectedType === boot.type
          ? "bg-[#ff6f61] hover:bg-[#ff8b7c] shadow-lg"
          : "bg-[#1a2a6c] hover:bg-[#142057]"
      }
      p-4 sm:p-6 lg:p-10`}
            >
              <img
                src={boot.icon}
                alt={`${boot.label} afbeelding`}
                className={`mb-4 object-cover transition-all
        w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24
        ${selectedType === boot.type ? "scale-105 opacity-100" : "opacity-80"}`}
              />
              <dd
                className={`text-xl sm:text-2xl lg:text-3xl font-semibold tracking-tight transition-all
        ${selectedType === boot.type ? "text-white" : "text-[#ff6f61]"}`}
              >
                {boot.label}
              </dd>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <button
            onClick={handleNext}
            disabled={!selectedType}
            className={`px-6 py-3 rounded-md font-bold transition duration-200 ${
              selectedType
                ? "bg-[#ff6f61] text-[#1a2a6c] hover:bg-[#ff8b7c] shadow-lg"
                : "bg-gray-400 text-white cursor-not-allowed"
            }`}
          >
            Volgende
          </button>
        </div>
      </div>
    </div>
  );
};

export default BoatType;
